import { Address } from '@freighthub/freighthub-corelib'

export type PartialAddress = Partial<Pick<Address, 'country' | 'street' | 'streetNumber' | 'city' | 'postalCode'>>
export const getFullAddress = (address?: PartialAddress): string => {
  if (!address || !address.country) return ''
  const addressLine1 = `${address?.street ?? ''} ${address?.streetNumber ?? ''}`.trim()
  const addressLine2 = `${address.city ?? ''} ${address.postalCode ?? ''}`.trim()
  return [addressLine1, addressLine2, address.country].filter(Boolean).join(', ')
}
